// src/components/common/Footer.js
import React from 'react';

const Footer = () => {
  return (
    <footer className="footer">
      <p>© {new Date().getFullYear()} World Tower Residence. All rights reserved.</p>
      <p>※掲載内容は変更になる場合がございます。</p>
    </footer>
  );
};

export default Footer;